<template>
  <div class="relative">
    <input
      :id="id"
      type="search"
      name="search"
      :placeholder="placeholder ? placeholder : $t('search')"
      class="
        peer size-full items-center justify-between gap-5 rounded-none border-b bg-grey-100 py-[0.90625rem]
        pl-4 pr-5 typo-subtitle
      "
      :value="value"
      @input="debounceInput(($event.target as HTMLInputElement).value)"
    />
    <div class="absolute right-4 top-4 hidden peer-placeholder-shown:block">
      <template v-if="$slots.icon">
        <slot name="icon" />
      </template>
      <IconMagnifyingGlass v-else class="size-7" />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  id: string
  value: string
  placeholder?: string
}>()

const emit = defineEmits(['input'])

const debounceInput = useDebounceFn((value: string) => {
  emit('input', value)
}, 300)
</script>
